export default __webpack_public_path__ + "static/media/archive.a2dbb4bb.svg";